export type FormKey = FormTask | BulkPrintTask | SystemTask;

export enum FormTask {
  BuildForm = 'buildForm',
  ViewForm = 'viewForm',
  ReviewForm = 'reviewForm',
  ViewReview = 'viewReview',
  AddressReview = 'addressReview',
  ViewCompleteForm = 'viewCompleteForm',
}

export enum BulkPrintTask {
  DownloadZip = 'bulkPrintDownloadPrint',
}

export enum SystemTask {
  BulkPrintGeneratePDF = 'bulkPrintGeneratePDF',
  BulkPrintGenerateZip = 'bulkPrintGenerateZip',
  BulkPrintDeletePDFs = 'bulkPrintDeletePDFs',
  BulkPrintDeleteZip = 'bulkPrintDeleteZip',
  DqaBatch = 'dqaBatch',
  DqaRequest = 'dqaRequest',
  GeneratePDF = 'generatePDF',
  FormWorkflowCancellation = 'cancelForm',
  SaveRiskToProfile = 'saveRiskToProfile',
  SaveQualityToProfile = 'saveQualityToProfile',
  SaveConfirmedRiskToPerson = 'saveConfirmedRiskToPerson',
}
